import PageWrapper from "../../shared/wizard/PageWrapper";
import {
  states,
  countries,
  US,
  Mexico,
  expandedStates,
  Canada,
} from "../../../constants/data";
import Styles from "../AnonForms.module.css";

function IncidentLocation({
  fields,
  utilities,
}) {
  const {
    createNoLabelInput,
    createNoLabelSelect,
    createWizInput,
    createWizSelect
  } = utilities;

  return (
    <div>
      <PageWrapper legendInfo="Incident Location:">
        <div className={Styles.labelInputContainer}>
          <div className={Styles.inputContainer}>
            {createWizInput(fields.whereAddress, "50%", Styles.anonInput)}
            {createNoLabelInput(fields.whereCity, "50%", Styles.anonInput)}
          </div>
          <div className={Styles.inputContainer}>
            <div className={Styles.isRow}>
              {fields.whereCountry.value === US.name ? (
                <>
                {createNoLabelSelect(
                  fields.whereState,
                  "100%",
                  states,
                  Styles.anonSelect,
                  "Select a State"
                )}
                </>
              ) : fields.whereState.value === Mexico.name 
              ? (
                <>
                {createNoLabelInput(
                  fields.whereCountry,
                  "100%",
                  Styles.anonInput
                )}
                </>
              ) : (
                createNoLabelSelect(
                  fields.whereCountry,
                  "100%",
                  expandedStates
                    .filter(state => state.country.code === Canada.code)
                    .map(item => item.state),
                  Styles.anonSelect,
                  "Select a Province"
                )
              )}
            </div>
            {createNoLabelInput(fields.whereZipcode, "100%", Styles.anonInput)}
            {createNoLabelInput(fields.whereCounty, "100%", Styles.anonInput)}
          </div>

          <div className={Styles.inputContainer}>
            {createWizSelect(
              fields.whereCountry,
              "33%",
              countries.map(country => country.name),
              Styles.anonSelect,
              false
              )}
          </div>
        </div>
      </PageWrapper>
    </div>
  );
}

export default IncidentLocation;
